/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 15:20:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-23 11:18:59
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/OtherInformation/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Table from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { columns } from '../config';
import css from '../css.module.less';
import AddInformation from './AddInformation';

const OtherInformation = ({
  information,
  setShowModal,
  setModalTitle,
  setModalContent,
  addInformation: addInformationFun,
  editInformation: editInformationFun,
  deleteInformation: deleteInformationFun,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const addInformation = () => {
    setShowModal(true);
    setModalTitle(getI18n('storeLogistics.packingSlip.addMoreInformation'));
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={addInformationFun}
      />,
    );
  };
  const deleteInformation = (record) => {
    deleteInformationFun(record);
  };
  const editInformation = (record) => {
    setShowModal(true);
    setModalTitle(getI18n('storeLogistics.packingSlip.editInformation'));
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={editInformationFun}
        defaultData={record}
      />,
    );
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('storeLogistics.packingSlip.otherInformationTitle')}
      subtitle={getI18n('storeLogistics.packingSlip.otherInformationSubTitle')}>
      <Table
        id='information'
        rowKey='uuid'
        className={css.globalTable}
        columns={columns(deleteInformation, editInformation, { getI18n })}
        dataSource={information}
      />
      <Button
        className={css.addInformation}
        type='primary'
        onClick={addInformation}>
        {getI18n('storeLogistics.packingSlip.addMoreInformation')}
      </Button>
    </SectionWrapper>
  );
};

export default OtherInformation;
